// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarClock16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-clock': IconCalendarClock;
    }
}

/**
 * The icon component for the 'calendarClock' icon
 */
export class IconCalendarClock extends Icon {
    public constructor() {
        super(calendarClock16X16);
    }
}

registerIcon('icon-calendar-clock', IconCalendarClock);
export const iconCalendarClockTag = 'nimble-icon-calendar-clock';
